import { api } from './api';
import config from 'config';
import { hasValue } from 'swipeclock-frontend';

export const hubApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAcknowledgeReadReceipts: build.query({
      query: () => ({
        url: `${config.hubApiUrl}/items/pendingacknowledge`,
        method: 'GET',
      }),
      transformResponse: (res) => {
        if (hasValue(res)) {
          return res;
        }

        return [];
      },
      providesTags: () => {
        return [{ type: 'hub', id: `READ_RECEIPTS` }];
      },
    }),
    acknowledgeReadReceipt: build.mutation({
      query: ({ body }) => {
        return {
          url: `${config.hubApiUrl}/items/acknowledge`,
          method: 'POST',
          body,
        };
      },
    }),
    getFileDownloadToken: build.mutation({
      query: (id) => {
        return {
          url: `${
            config.hubApiUrl
          }/items/documents/downloadToken?itemType=FileCabinetDocuments&downloadId=${encodeURIComponent(
            id
          )}&expirationSeconds=45`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetAcknowledgeReadReceiptsQuery,
  useAcknowledgeReadReceiptMutation,
  useGetFileDownloadTokenMutation,
} = hubApi;
